var _excluded = ["render", "children"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";
import PropTypes from "prop-types";
import FormManager from "./form-manager";

var ManagedForm = function ManagedForm(_ref) {
  var render = _ref.render,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var renderProp = typeof render === "function" ? render : children;
  return /*#__PURE__*/React.createElement(FormManager, props, function (_ref2) {
    var isDisabled = _ref2.isDisabled,
        state = _ref2.state,
        setState = _ref2.setState,
        errors = _ref2.errors,
        handleSubmit = _ref2.handleSubmit;
    return /*#__PURE__*/React.createElement("form", {
      autoComplete: props.disableAutoComplete ? "off" : "on",
      onSubmit: function onSubmit(e) {
        e.preventDefault();

        if (!props.disableEnterKeyOnForm) {
          handleSubmit(state, setState);
        }
      }
    }, renderProp({
      state: state,
      setState: setState,
      errors: errors,
      isDisabled: isDisabled
    }));
  });
};

ManagedForm.propTypes = {
  render: PropTypes.func,
  children: PropTypes.func,
  disableAutoComplete: PropTypes.bool,
  disableEnterKeyOnForm: PropTypes.bool
};
ManagedForm.displayName = "ManagedForm";
export default ManagedForm;